module.exports = __webpack_public_path__ + "img/arrow-up-right-from-square-solid.74a2b764.svg";